import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Divider, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import useRegions from '@/common/hooks/useRegions/useRegions'

import AvailabilityCountryChip from './AvailabilityCountryChip/AvailabilityCountryChip'
import ReturnProtectionGeneralConfigurationSkeleton from './ReturnProtectionGeneralConfigurationSkeleton/ReturnProtectionGeneralConfigurationSkeleton'
import { getReturnProtectionCountries } from './helpers'
import * as Styles from './styles'

const ReturnProtectionGeneralConfiguration = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { regions, loading: fetchingRegions } = useRegions()

  if (fetchingRegions) return <ReturnProtectionGeneralConfigurationSkeleton />

  const countries = getReturnProtectionCountries(info.selectedStore.return_protection, regions)

  return (
    <Styles.Container>
      <Text type="bodyMRegular">
        {t('Configura cómo se ve Return Protection para tus clientes y dónde está disponible en tu tienda.')}
      </Text>
      <Divider />
      <Styles.Section>
        <Text type="titleM">{t('Disponibilidad')}</Text>
        <Text type="bodyMRegular">
          {t(
            'Return Protection está activado para toda tu tienda. Estos son los países y regiones donde se ofrece actualmente a los clientes en el checkout.'
          )}
        </Text>
        <Styles.Tags>
          {countries.map(country => (
            <AvailabilityCountryChip key={country.id} country={country} />
          ))}
        </Styles.Tags>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t('La cobertura la gestiona Reveni según tu plan.')}
        </Text>
      </Styles.Section>
    </Styles.Container>
  )
}

export default ReturnProtectionGeneralConfiguration
